/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(function() {
  !!_CF.eta && _CF.eta();
  !!_CF.packSizes && _CF.packSizes();
  !!_CF.wbPrice && _CF.wbPrice();

  !!_CF.ftReviews && _CF.ftReviews();

  !!_CF.structuralContactForPrice && _CF.structuralContactForPrice();
  !!window.cbCalculator && cbCalculator.init();
  !!window.ctssCalculator && ctssCalculator.init();
  !!window.ctssCart && window.ctssCart();


  $(document).on('click', '.js-toggle-show-text', function() {
    var t = $(this),
        parent = t.parents('.js-qty-block');
    parent.toggleClass('js-show-text');
    t.find('.fa').toggleClass('fa-chevron-down fa-chevron-up')
  });

  if (window.RQ) {
    !!RQ.selectProducts && RQ.selectProducts()
    // !!RQ.customQuotePrice && RQ.customQuotePrice()
    !!RQ.fileUpload && RQ.fileUpload()
    // !!RQ.deleteQuotes && RQ.deleteQuotes()
    !!RQ.email && RQ.email()
    // !!RQ.generateSheetPreivew && RQ.generateSheetPreivew()
    // !!RQ.generateFilesPreview && RQ.generateFilesPreview()
    // !!RQ.convertItemsToOrder && RQ.convertItemsToOrder()
    !!RQ.downloadQuote && RQ.downloadQuote();
    !!RQ.acceptQuotes && RQ.acceptQuotes();

    !!RQ.aqpInit && RQ.aqpInit();
  }
  
  !!_CF.zipTriggerChat && _CF.zipTriggerChat();
  // !!_CF.cheaperPriceForm && _CF.cheaperPriceForm();

  
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; 
    var availbility = document.querySelector('.js-variant-availbility');
    if (!availbility) return;
    if (!variant) return availbility.innerHTML =  'Unavailable';

    var variantInventoryContinue = JSON.parse(availbility.getAttribute('data-variants-inventory-continue'))[variant.id]
    

    var availbilityText = (function() {
      if (variant.available) {
        if (variantInventoryContinue) return 'In stock';
        return 'In stock'
      } else {
        return 'Out of stock'
      }
    })();

    availbility.innerHTML = availbilityText; 
  });

  if (window.DN) {
    DN.init()
    !!DN.proofOfDelivery && DN.proofOfDelivery()
  } 

  !!_CF.factoryView && _CF.factoryView();
  !!_CF.yardView && _CF.yardView();

  
})